import React, { useState } from 'react';
import { XCircle } from 'lucide-react';
import { InfoBox, InputGroup } from '../Common';

const ConsLossTool = () => {
    const [wr, setWr] = useState(45);
    const [tpd, setTpd] = useState(3);
    const [tdpy, setTdpy] = useState(250);

    const trades = tpd * tdpy;
    const den = Math.log(1 / (1 - (wr / 100)));
    const exp = den === 0 ? 0 : Math.log(trades) / den;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Consecutive Loss Probability</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Win Rate %" value={wr} onChange={setWr} />
                <InputGroup label="Trades Per Day" value={tpd} onChange={setTpd} />
                <InputGroup label="Trading Days/Yr" value={tdpy} onChange={setTdpy} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-red">
                    <div className="tct-data-row"><span className="tct-label">Expected Streak</span><span className="tct-value big-value val-red">≈ {Math.round(exp)} trades</span></div>
                </div>
            </div>
            <InfoBox
                title="Why Losing Streaks Are Normal in Trading"
                meta="Learn how probability explains losing streaks and why traders should expect consecutive losses."
                sections={[
                { title: "Introduction", content: "Even profitable strategies experience losing streaks.<br>Probability theory explains why this happens." },
                { title: "Example", content: "Win rate = 45%<br><br>Expected losing streak over many trades:<br>Approximately 6 losses in a row." },
                { title: "Why It Matters", content: "Understanding this helps traders:<br>• avoid emotional decisions<br>• stick to their strategy<br>• manage risk properly." }
                ]}
            />
        </div>
    );
};

export default ConsLossTool;
